(() => {
  if (window.__headerMobileSearchLoaded) return;
  window.__headerMobileSearchLoaded = true;

  const openingClass = 'search-opening';
  const closeDelay = 400;
  const closeTimers = new WeakMap();

  const focusInput = (drawer) => {
    const input = drawer.querySelector('.header-mobile-search__input');
    if (!input) return;

    requestAnimationFrame(() => {
      input.focus({ preventScroll: true });
    });
  };

  const openDrawer = (drawer) => {
    window.clearTimeout(closeTimers.get(drawer));
    drawer.setAttribute('open', '');
    drawer.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden-tablet');

    requestAnimationFrame(() => {
      drawer.classList.add(openingClass);
      focusInput(drawer);
    });
  };

  const closeDrawer = (drawer) => {
    drawer.classList.remove(openingClass);
    drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-tablet');

    window.clearTimeout(closeTimers.get(drawer));
    closeTimers.set(
      drawer,
      window.setTimeout(() => {
        drawer.removeAttribute('open');
      }, closeDelay)
    );
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest?.('.header-mobile-search__summary');
    if (summary) {
      const drawer = summary.closest('.header-mobile-search');
      if (!drawer) return;

      event.preventDefault();
      drawer.open && drawer.classList.contains(openingClass) ? closeDrawer(drawer) : openDrawer(drawer);
      return;
    }

    const closeButton = event.target.closest?.('.header-mobile-search__close');
    if (closeButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const drawer = closeButton.closest('.header-mobile-search');
      if (drawer) closeDrawer(drawer);
      return;
    }

    const overlay = event.target.closest?.('.header-mobile-search__overlay');
    if (!overlay || event.target !== overlay) return;

    const drawer = overlay.closest('details');
    if (drawer) closeDrawer(drawer);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.code?.toUpperCase() !== 'ESCAPE') return;

    const drawer = event.target.closest?.('.header-mobile-search[open]');
    if (drawer) closeDrawer(drawer);
  });
})();
